type ButtonProps = {
  text: string;
  disabled?: boolean;
  className?: string
};

export const Button = (props: ButtonProps) => {
  return (
    <button
      className={`${props.className} px-5 py-2 rounded-lg primary-btn cursor-pointer`}
      disabled={props.disabled}
    >
      {props.text}
    </button>
  );
};
